
<template>
  <div class="root-container">
    <el-table
      :data="steps"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      border>
      <!--<el-table-column prop="number" label="编号" width="100"></el-table-column>-->
      <el-table-column prop="step"   label="目标" >
      </el-table-column>
      <el-table-column prop="value"  label="目标值" >
      </el-table-column>
    </el-table>

  </div>

</template>

<style>

  .root-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>

<script>

  import commonUtils from "../../../utils/commonUtils";

  export default {
    name: 'CmiStepFrom',
    props: {
      steps :Array,
      stepType:Object,
    },
    data() {
      return {
        cmiStep:[],
        labelTag:"目标",
        labelVal:"目标值"
      }
    },
    mounted() {

    },
    created(){
      if (this.stepType == 0){
        this.labelTag = "业绩"
        this.labelVal = "提成比例"
      }else if (this.stepType ==2){
        this.labelTag = "上课类型"
        this.labelVal = "课时费"
      }
    },
    methods: {

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/salary-commisson/CmiStepFrom.vue